const semSolicitacaoJson = ({ solicitacaoJson, ...rest }) => rest;

export const removeSolicitacaoJson = processo =>
  processo && semSolicitacaoJson(processo);

export const toTramitePayload = ({ processo, processos = [], ...wrapper }) => ({
  ...wrapper,
  processo: removeSolicitacaoJson(processo),
  processos: processos.map(removeSolicitacaoJson)
});
